// extracted by mini-css-extract-plugin
export default {"topLeft":"setCorners_topLeft__cQnwc","topRight":"setCorners_topRight__73LK4","bottomLeft":"setCorners_bottomLeft__Mr4JP","bottomRight":"setCorners_bottomRight__C7kD4"};